import HttpService from 'services/http'
import NotificacionService from 'services/notification';

export const ASERTA_STATUS_PENDING = '0';
export const ASERTA_STATUS_LOADING = '1';
export const ASERTA_STATUS_FINISHED = '2';
export const ASERTA_STATUS_ERROR = '3';

class CompaniesService {

  static statusOptions = {
    'Pendiente': ASERTA_STATUS_PENDING,
    'Calculando Scoring': ASERTA_STATUS_LOADING,
    'Finalizado': ASERTA_STATUS_FINISHED,
    'Error': ASERTA_STATUS_ERROR,
  };

  static getNameStatus(id) {
    let name = '';
    for (let key in this.statusOptions) {
      if (id == this.statusOptions[key])
        name = key;
    }
    return name;
  }

  static excel(filters){
    return new Promise((resolve, reject) => {
      let path = '/companies/export-excel/';
      HttpService.getFile(path, filters)
      .then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    })
  }

  static list(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static add(data) {
    return new Promise((resolve, reject) => {
      let path = '/companies/';
      HttpService.post(path, data).then((response) => {
        NotificacionService.notify('Se ha creado la empresa correctamente');
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static get(id) {
    return new Promise((resolve, reject) => {
      let path = '/companies/' + id;
      HttpService.get(path).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static uploadManinvest(data) {
    return new Promise((resolve, reject) => {
      let path = '/tenders/import-excel/';
      HttpService.upload(path, data).then((response) => {
        NotificacionService.notify('Se han importado los datos correctamente');
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static upload(data) {
    return new Promise((resolve, reject) => {
      let path = '/companies/import-batch/';
      HttpService.upload(path, data).then((response) => {
        NotificacionService.notify('Se han importado los datos correctamente');
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static setScoringData(scoring, data) {
    return new Promise((resolve, reject) => {
      let path = '/scorings/' + scoring + '/';
      HttpService.patch(path, data).then((response) => {
        NotificacionService.notify('Se han guardado los datos correctamente');
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getScoring(filters) {
    return new Promise((resolve, reject) => {
      let path = '/scorings/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getTenders(filters) {
    return new Promise((resolve, reject) => {
      let path = '/tenders/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getAddreses(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/addresses/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getContacts(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/contacts/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getShareholders(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/shareholders/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getShareholdings(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/shareholdings/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getAdministrators(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/administrators/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getExecutives(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/executives/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static getLegal(filters) {
    return new Promise((resolve, reject) => {
      let path = '/companies/legal-incidents/';
      HttpService.get(path, filters).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static calculateScoring(company) {
    return new Promise((resolve, reject) => {
      let path = '/companies/' + company + '/calculate-scoring/';
      HttpService.post(path).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

}

export default CompaniesService;


// WEBPACK FOOTER //
// ./services/companies.js